import { render, staticRenderFns } from "./VerticalNavMenuItems.vue?vue&type=template&id=597e4676&scoped=true"
import script from "./VerticalNavMenuItems.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuItems.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuItems.vue?vue&type=style&index=0&id=597e4676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597e4676",
  null
  
)

export default component.exports